<template>
	<div class="publish_item position-relative">
		<div class="base_info">
			<span class="title" style="font-size: 1rem;font-weight: bold;position: relative">基本信息</span>
			<div class="upload_main_pic" style="margin-top: 1.56rem;">
				<div class="d-flex j-start a-center" style="margin-bottom: 1.19rem;">
					<span class="second_title position-relative" style="font-size: 0.75rem;font-weight: bold;">上传商品主图<span style="color: red;">(选配商品主图必填*)</span></span>
				</div>
				<div class="d-flex a-center flex-wrap">
					<el-upload style="width: 7.5rem;height: 7.5rem;margin-right: 10px;margin-bottom: 1rem;position: relative;" class="avatar-uploader" 
					action="upload"
					:http-request="handleUploadFile"
					:show-file-list="false" 
					:on-progress="uploadPicProcess" 
					:on-remove="handleRemove"
					:on-change="getGoodsimg"
					:before-upload="beforeAvatarUpload">
						<div class="position-absolute d-flex a-center j-center" style="top: 0;left: 0;right: 0;width: 100%;height: 20px;background-color: rgba(0,0,0,0.3);color: white;font-size: 14px;">商品主图</div>
						<img style="width: 100%;height: 100%;border-radius: 6px;" :src="goodsmsg.goods_img" v-if="goodsmsg.goods_img" alt="">
						<div v-else class="h-100 d-flex flex-column j-center a-center">
							<img src="../../assets/itemStore/tianjia@2x.png" alt="" style="width: 2.31rem;height: 2.32rem;">
							<span style="line-height: 1;color: #1E69FF;font-size: 0.75rem;">添加上传图片</span>
						</div>
						<el-progress v-if="imgflag" type="circle" v-bind:percentage="percenTage"></el-progress>
					</el-upload>
				</div>
			</div>
			<div class="item_title" style="margin-top: 2.75rem;">
				<div class="d-flex j-start a-center" style="margin-bottom: 1.19rem;">
					<span class="second_title position-relative" style="font-size: 0.75rem;font-weight: bold;">商品标题<span style="color: red;">(必填*)</span></span>
				</div>
				<input type="text" placeholder="请输入商品标题最多30个字" v-model="goodsmsg.goods_name" style="width: 48.44rem;height: 1.88rem;padding: 0 1.06rem;box-sizing: border-box; border:1px solid #1E69FF;border-radius: 4px; outline-color: #1E69FF;margin: 0 auto;display:block;">
			</div>
			<div class="specification" style="margin-top: 2.75rem;">
				<div class="d-flex j-start a-center" style="margin-bottom: 1.19rem;">
					<span class="second_title position-relative" style="font-size: 0.75rem;font-weight: bold;">规格参数（非必填）</span>
				</div>
				<el-upload style="width: 7.5rem;height: 7.5rem;position: relative;" class="avatar-uploader"
				action="upload"
				:http-request="handleUploadFile"
				:show-file-list="false" 
				:on-progress="uploadPicProcess"
				:on-remove="handleRemove"
				:on-change="getProductimg"
				:before-upload="beforeAvatarUpload">
					<div class="position-absolute d-flex a-center j-center" @click.stop="productimgClick" v-if="goodsmsg.product_img" style="bottom: 0;left: 0;right: 0;width: 100%;height: 20px;background-color: rgba(0,0,0,0.3);color: white;font-size: 14px;">删除</div>
					<img style="width: 100%;height: 100%;border-radius: 6px;" :src="goodsmsg.product_img" v-if="goodsmsg.product_img" alt="">
					<div v-else class="h-100 d-flex flex-column j-center a-center">
						<img src="../../assets/itemStore/tianjia@2x.png" alt="" style="width: 2.31rem;height: 2.32rem;">
						<span style="line-height: 1;color: #1E69FF;font-size: 0.75rem;">添加上传图片</span>
					</div>
				</el-upload>
			</div>
			<div class="item_detail" style="margin-top: 2.75rem;">
				<div class="d-flex j-start a-center" style="margin-bottom: 1.19rem;">
					<span class="second_title position-relative" style="font-size: 0.75rem;font-weight: bold;">商品详情<span style="color: red;">(必填*)</span></span>
				</div>
				<div style="width: 48.44rem;height: 53.5rem;margin: 0 auto;border: 2px solid #BBBBBB;border-radius: 4px;position: relative;">
					<div class="d-flex j-sb a-center" style="height: 3.13rem;width: 100%;background:linear-gradient(0deg, #F8F8F8 0%, #FFFFFF 100%);padding: 0 13.75rem;box-sizing: border-box; border-bottom: 2px solid #BBBBBB;font-size: 0.75rem;color: #666666;">
						<div class="d-flex flex-column j-center a-center">
							<el-upload 
							class="upload-demo" 
							list-type="picture" 
							multiple
							action="upload"
							:http-request="handleUploadFile"
							:show-file-list="false" 
							:on-progress="uploadPicProcess" 
							:on-remove="handleRemove"
							:on-change="getDescmobile"
							:before-upload="beforeAvatarUpload"
							>
								<div class="d-flex flex-column j-center a-center">
									<img src="../../assets/itemStore/tupian@2x.png" alt="" style="width: 1.4rem;height: 1.4rem;">
									<span>图片</span>
								</div>
							</el-upload>
						</div>
						<div class="d-flex flex-column j-center a-center" style="cursor: pointer;" @click="moveup">
							<img src="../../assets/itemStore/shangyi@2x.png" alt="" style="width: 1.4rem;height: 1.4rem;">
							<span>上移</span>
						</div>
						<div class="d-flex flex-column j-center a-center" style="cursor: pointer;" @click="movedown">
							<img src="../../assets/itemStore/xiayi@2x.png" alt="" style="width: 1.4rem;height: 1.4rem;">
							<span>下移</span>
						</div>
						<div class="d-flex flex-column j-center a-center" style="cursor: pointer;" @click="delDescimg">
							<img src="../../assets/itemStore/shangchu@2x.png" alt="" style="width: 1.4rem;height: 1.4rem;">
							<span>删除</span>
						</div>
					</div>
					<div style="width: 100%;height: 50.3rem;overflow-y: scroll;">
						<div v-for="(item,index) in goodsmsg.desc_mobile">
							<img style="width: 100%;" :src="item" alt="" @click="descimgCli(index)">
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="sale_property d-flex" style="margin-top: 3.69rem;justify-content: flex-start;">
			<div class="unify_price" style="margin-top: 1.56rem;margin-right: 3.75rem;">
				<div style="margin-bottom: 1.19rem;">
					<span class="second_title position-relative" style="font-size: 0.75rem;font-weight: bold;">商品定价:</span>
					<input v-model="goodsmsg.shop_price" type="text"  placeholder="设置统一价格" style="max-width: 10.3rem;height: 1.88rem;text-align: center;border-radius: 4px;border: 2px solid #BBBBBB;outline: none;margin-left: 1.5rem;">元
				</div>
			</div>
		</div>
		<div class="buttons d-flex a-center" style="justify-content: space-around;">
			<!-- <div class="button">保存草稿</div> -->
			<div class="button" style="color: #FFFFFF;border-color: #000000;color: #000000;box-sizing: border-box;">保存草稿</div>
			<div class="button" style="background: #226CFF;color: #FFFFFF;border-color: #226CFF;box-sizing: border-box;" @click="publishGoods">发布</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				goodsmsg : {},
				goodsImgbase64 : '', //商品主图base64
				descMobilebase64 : [], //商品详情图base64
				productImgbase64 : '', //商品规格图base64
				goodsGallerybase64 : [], //轮播图base集合
				descIndex : 0,
				shopoptions : [],
				cat_id : '', //商品分类id
				user_cat : '', //店铺分类id
				imgs: [
					{
						is_main: true,
						flag: '',
						is_show: '',
						percenTage: '',
						url: ''
					},{
						is_main: false,
						flag: '',
						is_show: '',
						percenTage: '',
						url: ''
					},{
						is_main: false,
						flag: '',
						is_show: '',
						percenTage: '',
						url: ''
					},{
						is_main: false,
						flag: '',
						is_show: '',
						percenTage: '',
						url: ''
					},{
						is_main: false,
						flag: '',
						is_show: '',
						percenTage: '',
						url: ''
					}
				],
				selected: '',
				videoFlag: false,
				//是否显示进度条
				videoUploadPercent: "",
				//进度条的进度，
				isShowUploadVideo: false,
				//显示上传按钮
				video_url: '',
				dialogImageUrl: '',
				dialogVisible: false,
				title: '',
				options: [],
				shop_classify: '',
				custom_color: '',
				custom_specification: '',
				unify_price: 2000,
				unify_stock: 2000,
				percenTage :0,
				imgflag :false,
				catName : '',
				goods_attr : [],
				goods_type : '',
				attrarr : [],
				attrarr1 :[],
				norms : [],
				attrImg : '',
				goods_attr_id_img : [],
				goods_product_info : [],
				imgInd : false,
				imgName :[],
				imgUrl : [],
				rgbaState :false,
				minNumber : '',
				maxNumber : '',
				shop_price : '',
				id : ''
			}
		},
		methods: {
			getoptionalMsg(){
				let param = {
					act : 'goods_optional_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					gop_id : this.id
				}
				this.$api.goods_list(param).then((res)=>{
					if(res.code == 0){
						this.goodsmsg = res.data
					}else{
						this.$message({
							type : 'error',
							message : res.msg
						})
					}
				})
			},
			// 获取图片转base64
			getBase64(file) {
				return new Promise(function(resolve, reject) {
					const reader = new FileReader()
					let imgResult = ''
					reader.readAsDataURL(file)
					reader.onload = function() {
						imgResult = reader.result
					}
					reader.onerror = function(error) {
						reject(error)
					}
					reader.onloadend = function() {
						resolve(imgResult)
					}
				})
			},
			// 图片转base64
			getFile(file, fileList) {
				this.getBase64(file.raw).then(res => {
					let params = res.split(',')
					if (params.length > 0) {
						this.strimagebase64 = res
						// this.handleUploadFile()
						let param = {
							act: 'public_upload_file',
							file: this.strimagebase64
						}
						this.$api.uploadPicture(param).then((res) => {
							if (res.code == 0) {
								this.attrImg = res.data
								this.$message.success('图片上传成功');
							} else {
								this.$message.error('图片上传失败');
							}
						}).catch(response => {
							this.$message.error('图片上传失败');
						})
					}
				})
			},
			handleUploadAttrimg() {
				
			},
			beforeUpload(file,ite){
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isLt2M;
			},
			handleHeadSuccess(res,file, index){
			},
			// 商品主图
			getGoodsimg(file,fileList){
				this.getBase64(file.raw).then(res => {
					let params = res.split(',')
					if (params.length > 0) {
						this.goodsImgbase64 = res
						// this.handleUploadFile()
						let param = {
							act: 'public_upload_file',
							file: this.goodsImgbase64
						}
						this.$api.uploadPicture(param).then((res) => {
							if (res.code == 0) {
								this.goodsmsg.goods_img = res.data
							} else {
								this.$message.error('图片上传失败');
							}
						}).catch(response => {
							this.$message.error('图片上传失败');
						})
					}
				})
			},
			// 规格图
			getProductimg(file,fileList){
				this.getBase64(file.raw).then(res => {
					let params = res.split(',')
					if (params.length > 0) {
						this.productImgbase64 = res
						// this.handleUploadFile()
						let param = {
							act: 'public_upload_file',
							file: this.productImgbase64
						}
						this.$api.uploadPicture(param).then((res) => {
							if (res.code == 0) {
								this.goodsmsg.product_img = res.data
							} else {
								this.$message.error('图片上传失败');
							}
						}).catch(response => {
							this.$message.error('图片上传失败');
						})
					}
				})
			},
			// 规格图删除
			productimgClick(){
				this.productImgbase64 = ''
				this.goodsmsg.product_img = ''
			},
			// 详情图
			getDescmobile(file,fileList){
				this.getBase64(file.raw).then(res => {
					let params = res.split(',')
					if (params.length > 0) {
						// this.descMobilebase64 = res
						// this.handleUploadFile()
						let param = {
							act: 'upload_desc_attr_pic',
							file: res,
							type : 1
						}
						this.$api.goods_list(param).then((res) => {
							if (res.code == 0) {
								this.goodsmsg.desc_mobile.push(res.data)
								this.descMobilebase64.push(res.data)
							} else {
								this.$message.error('图片上传失败');
							}
						}).catch(response => {
							this.$message.error('图片上传失败');
						})
					}
				})
			},
			descimgCli(index){
				this.descIndex = index
			},
			// 商品详情处理，上移，下移，删除
			swapArray(arr, index1, index2) {
			    arr[index1] = arr.splice(index2, 1, arr[index1])[0];
			    return arr;
			},
			moveup(){
				this.swapArray(this.goodsmsg.desc_mobile, this.descIndex, this.descIndex - 1);
				this.swapArray(this.descMobilebase64, this.descIndex, this.descIndex - 1);
			},
			movedown(){
				this.swapArray(this.goodsmsg.desc_mobile, this.descIndex, this.descIndex + 1);
				this.swapArray(this.descMobilebase64, this.descIndex, this.descIndex - 1);
			},
			delDescimg(){
				this.goodsmsg.desc_mobile.splice(this.descIndex,1)
				this.descMobilebase64.splice(this.descIndex,1)
			},
			handleUploadFile(){},
			getFileType(name) {
				let startIndex = name.lastIndexOf(".")
				if (startIndex !== -1) {
					return name.slice(startIndex + 1).toLowerCase()
				} else {
					return ""
				}
			},
			beforeAvatarUpload(file,fileList){
				let suffix = this.getFileType(file.name) //获取文件后缀名
				let suffixArray = ["jpg", "png", "jpeg", "gif"] //限制的文件类型，根据情况自己定义
				if (suffixArray.indexOf(suffix) === -1) {
					this.$message({
						message: "文件格式错误",
						type: "error",
						duration: 2000
					})
				}
				return suffixArray
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url
				this.dialogVisible = true
			},
			handlePictureCardSuccess(response, file, fileList) {
				this.video_url = fileList[0].url
			},
			uploadPicProcess(event, file, fileList, index) {
				this.imgflag = true;
				this.percenTage = file.percentage.toFixed(0) * 1;
			},
			//上传成功回调
			handleVideoSuccess(res, file) {
				this.isShowUploadVideo = true;
				this.videoFlag = false;
				this.videoUploadPercent = 0;

				// 前台上传地址
				if (file.status == 'success') {
					this.video_url = file.url;
					console.log(file)
				} else {
					this.$message({
						showClose: true,
						message: '上传失败，请重新上传',
						type: 'error'
					});
				}
			},
			add_specification() {
				this.size.push(this.custom_specification)
			},
			publishGoods(){
				if(!this.goodsmsg.goods_name){
					this.$message.warning('商品名称不能为空')
					return
				}
				if(!this.descMobilebase64){
					this.$message.warning('请上传商品详情图片')
					return
				}
				if(this.goodsmsg.shop_price == ''){
					this.$message.warning('商品定价不能为空')
					return
				}
				let param = {
					act : 'edit_goods_optional',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					goods_name : this.goodsmsg.goods_name,
					goods_img : this.goodsImgbase64,
					desc_mobile : this.goodsmsg.desc_mobile,
					product_img : this.productImgbase64,
					shop_price : this.goodsmsg.shop_price,
					gop_id : this.id
				}
				const loading = this.$loading({
					lock: true,
					text: '发布中',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				this.$api.goods_list(param).then((res) => {
					loading.close()
					if(res.code == 0){
						this.$message.success('编辑选配商品成功')
						this.$router.push({
							name: 'item_store'
						})
					}else {
						this.$message({
							type :'error',
							message : res.msg
						});
					}
				})
			},
			arraySpanMethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (rowIndex % 2 === 0) {
					if (columnIndex === 0) {
						return [1, 2];
					} else if (columnIndex === 1) {
						return [0, 0];
					}
				}
			},
			objectSpanMethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 0) {
					if (rowIndex % 2 === 0) {
						return {
							rowspan: 2,
							colspan: 1
						};
					} else {
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}
			}
		},
		mounted() {
			this.id = this.$route.params.id
			this.getoptionalMsg()
		}
	}
</script>

<style lang="scss">
	.el-cascader-menu {
		width: 33.3%;
	}

	.el-cascader-node {
		padding: 0 2rem 0 1rem !important;
	}

	.el-cascader {
		.el-input__inner {
			font-size: 0.75rem;
		}
	}

	.in-active-path {
		color: #1E69FF !important;
		background: #EEF4FF !important;

		&::before {
			content: '';
			width: 0.13rem;
			height: 1.25rem;
			background: #1E69FF;
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
		}
	}

	.is-active {
		color: #1E69FF !important;
		background: #EEF4FF !important;
	}

	.el-scrollbar__wrap {
		overflow: auto !important;
		margin-right: -6px !important;
	}

	.el-scrollbar__view,
	.el-cascader-menu__list {
		padding: 0 !important;
	}




	.avatar-uploader {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		box-sizing: border-box;
	}

	.el-upload--text {
		width: 100%;
		height: 100%;
	}

	.avatar-uploader:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 100%;
		height: 100%;
		line-height: 100%;
		text-align: center;
	}

	.avatar {
		width: 7.5rem;
		height: 7.5rem;
		display: block;
	}

	.el-upload-list--picture {
		position: absolute;
		left: 0;
		top: 3.13rem;
		width: 100% !important;

		.el-upload-list__item,
		.is-success {
			width: 100% !important;
			height: 100% !important;
		}
	}

	.el-progress,
	.el-progress--circle,
	.el-progress-circle {
		width: 100% !important;
		height: 100% !important;
	}
</style>
<style lang="scss" scoped>
	::-webkit-scrollbar {
	  display: none; /* Chrome Safari */
	}
	.text-suojin{
		 overflow: hidden;
		 text-overflow: ellipsis;
		 display: -webkit-box; 
		 -webkit-line-clamp: 2;
		 -webkit-box-orient: vertical;
	}
	.tableHead div:first-child{
		border-left: 2px solid #BBBBBB;
	}
	.tableBody div{
		border-top: 0px solid #BBBBBB !important;
	}
	input[type="checkbox"] {
		width: 1.13rem;
		height: 1.13rem;
		-webkit-appearance: none;
		border: 1px solid #c9c9c9;
		border-radius: 10px;
		outline: none;
		cursor: pointer;
	}

	input[type=checkbox]:checked {
		background: url("../../assets/itemStore/xuanzhong@2x.png")no-repeat;
		background-size: 100% 100%;
	}

	.publish_item {
		max-width: 73.13rem;
		box-sizing: border-box;
		margin: 1.25rem auto;
		background: #FFFFFF;
		padding: 1.81rem 0 3.63rem 0;

		.title::before {
			content: '';
			background: url(../../assets/itemStore/biaoqian@2x.png) no-repeat;
			background-size: 100%;
			width: 0.94rem;
			height: 1.19rem;
			position: absolute;
			left: -1.3rem;
			top: 50%;
			transform: translate(0, -50%);
		}

		.second_title::before {
			content: '';
			background: url(../../assets/itemStore/xiaobiao@2x.png) no-repeat;
			background-size: 100%;
			width: 0.44rem;
			height: 0.44rem;
			position: absolute;
			left: -1rem;
			top: 50%;
			transform: translate(0, -50%);
		}


		.sale_data {
			position: relative;
			width: 48.44rem;
			margin: 0 auto;

			.selected {}

			.select {
				height: 20rem;
			}
		}

		.base_info {
			width: 48.44rem;
			margin: 0 auto;
			margin-top: 3rem;
		}

		.sale_property {
			width: 48.44rem;
			margin: 0 auto;
		}

		.buttons {
			width: 48.44rem;
			margin: 0 auto;
			margin-top: 3.88rem;

			.button {
				width: 10.3rem;
				height: 1.8rem;
				border-radius: 0.9rem;
				text-align: center;
				line-height: 1.8rem;
				font-size: 0.75rem;
				border: 2px solid #000000;
				cursor: pointer;
			}
		}
	}
</style>
